import { Injectable } from '@angular/core';
import { UserService } from '../user/user.service';

function setCrewdleCookie(name: string, value: string): void {
  try {
    const date = new Date();
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
    document.cookie = `crewdle_${name}=${encodeURIComponent(value)};expires=${date.toUTCString()};path=/;domain=.crewdle.ai;SameSite=Lax`;
  } catch {}
}

function getCrewdleCookie(name: string): string | null {
  try {
    const prefix = `crewdle_${name}=`;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const trimmed = cookie.trim();
      if (trimmed.startsWith(prefix)) {
        return decodeURIComponent(trimmed.substring(prefix.length));
      }
    }
  } catch {}
  return null;
}

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(
    private userService: UserService,
  ) { }

  async getLanguage(): Promise<string | undefined> {
    // Check Firestore first (authoritative for logged-in users). Mirror the
    // result into localStorage + cookie so the synchronous reader in main.ts
    // can pick it up on the next boot — without this, users with a stored
    // preference different from navigator.language see a flash of the
    // browser-default locale before async Firestore resolves.
    const firestoreLang = await this.userService.getLanguagePreference();
    if (firestoreLang) {
      this.cacheLanguage(firestoreLang);
      return firestoreLang;
    }

    // Then check root domain cookie
    const cookieLang = getCrewdleCookie('lang');
    if (cookieLang) {
      window.localStorage.setItem('lang', cookieLang);
      return cookieLang;
    }

    // Then check localStorage
    const localLang = window.localStorage.getItem('lang');
    if (localLang) return localLang;

    return undefined;
  }

  private cacheLanguage(language: string): void {
    window.localStorage.setItem('lang', language);
    setCrewdleCookie('lang', language);
  }

  async setLanguage(language: string) {
    window.localStorage.setItem('lang', language);
    setCrewdleCookie('lang', language);
    await this.userService.updateLanguagePreference(language);
  }
}
